import { STATE_COLORS } from './statusColors';

// Mirrors src/Domain/Enums/EmailStatus.cs — values must match the backend exactly.
export const EMAIL_STATUS = Object.freeze({
  QUEUED: 'Queued',
  SENT: 'Sent',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
});

export const EMAIL_STATUS_LIST = [
  EMAIL_STATUS.QUEUED,
  EMAIL_STATUS.SENT,
  EMAIL_STATUS.FAILED,
  EMAIL_STATUS.SKIPPED,
];

export const EMAIL_STATUS_COLORS = Object.freeze({
  [EMAIL_STATUS.QUEUED]: STATE_COLORS.OPEN,
  [EMAIL_STATUS.SENT]: STATE_COLORS.COMPLETE,
  [EMAIL_STATUS.FAILED]: STATE_COLORS.ERROR,
  [EMAIL_STATUS.SKIPPED]: STATE_COLORS.DRAFT,
});
